export default __webpack_public_path__ + "static/prefabelementen-mobile-b37dfb68bf9349c09fd9a3c41dd294b9.svg";